import React from "react";
// import FontAwesomeIcon from '@fortawesome/react-fontawesome';
// import { Navbar } from 'react-bootstrap';
import { getParams } from './helper';


class Footer extends React.Component {
  constructor() {
      super();
      this.state = {
        token: getParams().jwt,
        organization_id: getParams().organization_id
      }
    }
    render() {
        return (
          this.props.login?(
            <div className="footer-login">
              {/* <div className="footer-first">
              </div> */}
              <div className="" style={{ display: "flex", flexDirection: "column", fontSize:"12px"}}>
                <div>Hoopstir Softwares For Sport Inc.</div>
                <div>
                  <a className="loginform-button-cancel" href={this.state.organization_id?document.location.origin + `/privacy?organization_id=${this.state.organization_id}`:
                                                                                document.location.origin + `/privacy`}>Privacy and Terms</a>
                  
                </div>
              </div>
              {/* <div className="footer-third"
              </div> */}
            </div>
          ):(
            <div className="footer">
              <div className="footer-first">
              </div>
              <div className="footer-second">
                Powered by Hoopstir &copy;
              </div>
              <div className="footer-third">
                 <a target="_blank" href={this.state.organization_id?document.location.origin + `/privacy?organization_id=${this.state.organization_id}`: document.location.origin + `/privacy`}>Privacy and Terms</a>
              </div>
            </div>
          )
        )
    }
}

export default Footer;
